module.exports = __webpack_public_path__ + "static/img/12.c3fed22e.jpeg";